'use client';

import { Toaster as Sonner } from 'sonner';
import { cn } from '@/lib/utils';
import { Info, CheckCircle2, AlertCircle, XCircle } from 'lucide-react';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      // Default to top-center for best mobile visibility/ergonomics for Firma
      position="top-center"
      expand={true}
      richColors
      closeButton
      icons={{
        success: <CheckCircle2 className="h-4 w-4 text-emerald-400" />,
        info: <Info className="h-4 w-4 text-blue-400" />,
        warning: <AlertCircle className="h-4 w-4 text-amber-400" />,
        error: <XCircle className="h-4 w-4 text-rose-400" />,
      }}
      toastOptions={{
        classNames: {
          toast: cn(
            'group toast',
            'group-[.toaster]:bg-zinc-950/90 group-[.toaster]:backdrop-blur-xl',
            'group-[.toaster]:text-white group-[.toaster]:border-zinc-800/50',
            'group-[.toaster]:shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)]',
            'group-[.toaster]:rounded-full group-[.toaster]:px-6 group-[.toaster]:py-3',
            'group-[.toaster]:border group-[.toaster]:ring-1 group-[.toaster]:ring-white/10'
          ),
          title: 'text-[13px] font-black tracking-tight leading-none',
          description: 'text-[11px] font-medium text-zinc-400 mt-0.5 leading-tight',
          actionButton:
            'group-[.toast]:bg-white group-[.toast]:text-zinc-950 group-[.toast]:rounded-full group-[.toast]:font-black group-[.toast]:text-[10px] group-[.toast]:px-4 group-[.toast]:h-8 group-[.toast]:uppercase group-[.toast]:tracking-widest group-[.toast]:transition-all active:scale-95',
          cancelButton:
            'group-[.toast]:bg-zinc-800 group-[.toast]:text-white group-[.toast]:rounded-full group-[.toast]:font-black group-[.toast]:text-[10px] group-[.toast]:px-4 group-[.toast]:h-8 group-[.toast]:uppercase group-[.toast]:tracking-widest',
          closeButton:
            'group-[.toast]:bg-zinc-900 group-[.toast]:text-zinc-400 group-[.toast]:border-zinc-800 group-[.toast]:hover:bg-zinc-800 group-[.toast]:hover:text-white',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
